module.exports = __webpack_public_path__ + "img/limit-access.28a109b.svg";